import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://www.picklebullpen.com";
const DEFAULT = {
  title: "Pickle Bullpen — Pickleball Training, Leagues, Tournaments & Moneyball Events | Bradenton–Sarasota–Tampa Bay, FL",
  desc: "Pickleball training, competitive leagues, tournaments and Moneyball pickleball events across Bradenton, Sarasota, Lakewood Ranch, Ellenton, St. Pete and Tampa. AI video analysis, Player Skill Index, coaching and a full player development ecosystem — built in Florida, open to players everywhere.",
};
const PAGES = {
  "/": DEFAULT,
  "/welcome": DEFAULT,
  "/faq": {
    title: "Pickleball FAQ — Training, Leagues, Tournaments & Moneyball Events | Pickle Bullpen",
    desc: "Answers about Pickle Bullpen memberships, pickleball leagues, tournaments, Moneyball events, AI video analysis and the Player Skill Index in the Bradenton–Sarasota–Tampa Bay area.",
  },
  "/court-board": {
    title: "Live Pickleball Tournament Court Board | Pickle Bullpen",
    desc: "Live court assignments and match updates for Pickle Bullpen pickleball tournaments and Moneyball events.",
  },
  "/grails": {
    title: "Grail Gallery — One-of-One Pickleball Card Trophy Wall | Pickle Bullpen",
    desc: "Every one-of-one Pickle Bullpen sports card ever pulled and who owns it. Only one copy of each grail exists — see the wall and hunt yours.",
  },
  "/events": {
    title: "Pickleball Tournaments & Moneyball Events — Bradenton, Sarasota & Tampa Bay | Pickle Bullpen",
    desc: "Upcoming Pickle Bullpen pickleball tournaments, leagues and Moneyball events across Bradenton, Sarasota, Lakewood Ranch, St. Pete and Tampa — dates, entry fees and live registration.",
  },
  "/shops": {
    title: "Bullpen Merchant Shops — Pickleball Gear & Cards for Coins | Pickle Bullpen",
    desc: "Browse verified Pickle Bullpen merchant shops — pickleball gear, services and exclusive sports cards, all payable with BULLION COIN.",
  },
  "/auth": {
    title: "Join the Bullpen — Player Sign Up & Login | Pickle Bullpen",
    desc: "Create your free Pickle Bullpen player profile — track your Player Skill Index, join pickleball leagues, tournaments and Moneyball events in the Bradenton, Sarasota and Tampa Bay area.",
  },
};

export default function RouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/events/") || pathname.startsWith("/shops/")) return;
    const meta = PAGES[pathname] || DEFAULT;
    document.title = meta.title;
    const d = document.querySelector('meta[name="description"]');
    if (d) d.setAttribute("content", meta.desc);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `${BASE}${pathname === "/welcome" ? "/" : pathname}`);
  }, [pathname]);
  return null;
}
